<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'consultationManagement',
})
</script>
<template>
  <router-view v-if="$route.name !== 'consultation'" />
  <div v-else>
    <a-card>
      <div class="consultation-search">
        <a-form :model="state.tableData.param" class="global-search-form">
          <a-row :gutter="24">
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="提交日期">
                <a-range-picker v-model:value="state.dateRange" value-format="YYYY-MM-DD"
                  :placeholder="['开始日期', '结束日期']" style="width: 100%" :disabled-date="disabledDate"
                  :allow-empty="[true, true]" @calendar-change="onCalendarChange" @change="onDateChange"
                  @openChange="onOpenChange" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="4" class="mb-[10px]">
              <a-form-item label="咨询单号">
                <a-input v-model:value="state.tableData.param.consultationNo" placeholder="请输入咨询单号" :maxlength="50"
                  allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="5" class="mb-[10px]">
              <a-form-item label="咨询类型">
                <a-select v-model:value="state.tableData.param.categoryCode" placeholder="请选择咨询类型" allow-clear>
                  <a-select-option v-for="item in categoryList" :key="item.code" :value="item.code">{{ item.name
                    }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="4" class="mb-[10px]">
              <a-form-item label="手机号">
                <a-input v-model:value="state.tableData.param.phone" placeholder="请输入手机号" :maxlength="11" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="5" class="mb-[10px]">
              <div class="card-col-action flex flex-nowrap">
                <ant-button class="search mr-[10px]!" @click="getTableData" type="primary">
                  <SearchOutlined />查询
                </ant-button>
                <ant-button class="resetFun" @click="resetFun" type="primary">
                  <RedoOutlined />重置
                </ant-button>
              </div>
            </a-col>
            <!-- <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb-[10px]">
              <div class="card-col-action flex flex-nowrap">
                <ant-button class="add" @click="dialogRef?.openDialog()" type="primary">
                  <PlusOutlined />新增咨询
                </ant-button>
              </div>
            </a-col> -->
          </a-row>
        </a-form>
      </div>
      <!-- <div class="mb-[24px]">
        <ant-button class="add" @click="router.push({ path: '/consultation/add' })" type="primary"><PlusOutlined />新增咨询</ant-button>
      </div> -->
      <ant-table :columns="columns" :data-source="state.tableData.data" :loading="state.tableData.loading"
        :pagination="false" row-key="id">
        <template #bodyCell="{ column, record, index }">
          <template v-if="column.key === 'index'">{{ index + 1 }}</template>
          <template v-else-if="column.key === 'action'">
            <div class="table-action-left">
              <a-button type="link" size="small"
                @click="router.push({ name: 'consultationDetail', params: { id: record.id } })">查看详情</a-button>
              <a-button type="link" size="small" v-if="record.status === 0" @click="onConfirm(record)"
                v-auth="'consultation.dispose'">确认处理</a-button>
            </div>
          </template>
        </template>
      </ant-table>
      <ant-pagination v-model:current="state.tableData.param.pageNum" v-model:page-size="state.tableData.param.pageSize"
        :total="state.tableData.total" :page-size-options="['10', '20']" show-size-changer
        :show-total="(total) => `共 ${total} 条`" :showQuickJumper="true" @change="onPageChange"
        @show-size-change="onShowSizeChange" />
    </a-card>
    <ConsultationAddDialog ref="dialogRef" :store-list="storeList" :category-list="categoryList" :user-list="userList"
      @create-update="onCreateUpdate" />
  </div>
</template>

<script setup lang="ts" name="consultationManagement">
import { reactive, ref, onMounted, h, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { message, Modal } from 'ant-design-vue'
import { SearchOutlined, RedoOutlined, PlusOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { useConsultation } from '@/store/consultation/consultation'
import { useDictionary } from '@/store/system/dictionary'
import { useStore } from '@/store/shop/store'
import { useUser } from '@/store/user'
import { fetchWithPaginationFallback } from '@/utils/paginationFallback'
import dayjs from 'dayjs'
import ConsultationAddDialog from './add.vue'

const router = useRouter()
const route = useRoute()
const consultationStore = useConsultation()
const dictionaryStore = useDictionary()
const storeStore = useStore()
const userStore = useUser()

const dialogRef = ref()

const columns = [
  { title: '序号', key: 'index', width: 60 },
  { title: '咨询单号', dataIndex: 'consultationNo', key: 'consultationNo', ellipsis: true },
  { title: '咨询类型', dataIndex: 'categoryStr', key: 'categoryStr', ellipsis: true },
  { title: '店铺名称', dataIndex: 'storeName', key: 'storeName', ellipsis: true },
  { title: '用户昵称', dataIndex: 'userNickname', key: 'userNickname', ellipsis: true },
  { title: '手机号', dataIndex: 'phone', key: 'phone', ellipsis: true },
  { title: '处理状态', dataIndex: 'statusStr', key: 'statusStr', width: 100 },
  { title: '提交时间', dataIndex: 'submitTime', key: 'submitTime', width: 170 },
  { title: '操作', key: 'action', width: 200 }
]

const state = reactive({
  tableData: {
    data: [] as any[],
    total: 0,
    loading: false,
    param: {
      pageNum: 1,
      pageSize: 10,
      consultationNo: '',
      categoryCode: undefined as string | undefined,
      phone: '',
      start: '',
      end: ''
    }
  },
  dateRange: [] as (string | null)[]
})
const dates = ref<any[]>([])
const categoryList = ref<any[]>([])
const storeList = ref<any[]>([])
const userList = ref<any[]>([])

const onCalendarChange = (val: any[]) => {
  const newStart = val?.[0]
  const newEnd = val?.[1]

  // 情况1：清空
  if (!newStart && !newEnd) {
    dates.value = []
    return
  }

  // 情况2：当前已有完整旧区间，用户重新选择
  if (dates.value.length === 2 && dates.value[0] && dates.value[1]) {
    const oldStart = String(dates.value[0])
    const oldEnd = String(dates.value[1])

    // 没有变化，保持原样
    if ((!newStart || newStart === oldStart) && (!newEnd || newEnd === oldEnd)) {
      dates.value = [oldStart, oldEnd]
      return
    }

    const isStartChanged = !!(newStart && newStart !== oldStart)
    const isEndChanged = !!(newEnd && newEnd !== oldEnd)

    // 只改了开始时间
    if (isStartChanged && !isEndChanged) {
      handleStartChange(newStart, oldEnd)
      return
    }

    // 只改了结束时间
    if (!isStartChanged && isEndChanged) {
      handleEndChange(oldStart, newEnd)
      return
    }

    // 两个值都变了，根据新值与原值的距离判断改哪一端
    if (isStartChanged && isEndChanged) {
      const diffToStart = Math.abs(dayjs(newStart).diff(oldStart, 'days'))
      const diffToEnd = Math.abs(dayjs(newEnd).diff(oldEnd, 'days'))
      if (diffToStart <= diffToEnd) {
        handleStartChange(newStart, oldEnd)
      } else {
        handleEndChange(oldStart, newEnd)
      }
    }
    return
  }

  // 情况3：只选了一端（或刚补齐另一端）
  if (newStart && !newEnd) {
    dates.value = [newStart, undefined]
  } else if (!newStart && newEnd) {
    dates.value = [undefined, newEnd]
  } else if (newStart && newEnd) {
    // 当前是单端锚点状态，用户补齐了另一端
    dates.value = [newStart, newEnd]
  }
}

const handleStartChange = (newStart: string, oldEnd: string) => {
  const startDate = dayjs(newStart)
  const endDate = dayjs(oldEnd)
  const diffDays = endDate.diff(startDate, 'days')
  // 结束日期锚点清空，让用户继续选择；显示值在范围内保留，超出则清空
  dates.value = [newStart, undefined]
  if (diffDays >= 0 && diffDays <= 365) {
    state.dateRange = [newStart, oldEnd]
  } else {
    state.dateRange = [newStart, null]
  }
}

const handleEndChange = (oldStart: string, newEnd: string) => {
  const startDate = dayjs(oldStart)
  const endDate = dayjs(newEnd)
  const diffDays = endDate.diff(startDate, 'days')
  // 开始日期锚点清空，让用户继续选择；显示值在范围内保留，超出则清空
  dates.value = [undefined, newEnd]
  if (diffDays >= 0 && diffDays <= 365) {
    state.dateRange = [oldStart, newEnd]
  } else {
    state.dateRange = [null, newEnd]
  }
}

const onOpenChange = (open: boolean) => {
  if (open) {
    const [start, end] = state.dateRange
    if (start && end) {
      // 已有完整区间，重新打开时不限制任何一端
      dates.value = [start, end]
    } else if (start) {
      dates.value = [start, undefined]
    } else if (end) {
      dates.value = [undefined, end]
    } else {
      dates.value = []
    }
  } else {
    validateDateRange()
  }
}

const onDateChange = (val: (string | null)[]) => {
  if (val && val.length === 2) {
    const [startStr, endStr] = val
    if (startStr && endStr) {
      const start = dayjs(startStr)
      const end = dayjs(endStr)
      const diffDays = end.diff(start, 'days')
      if (diffDays < 0 || diffDays > 365) {
        // 静默处理：只清空超出范围的对应端
        if (dates.value[0] && !dates.value[1]) {
          state.dateRange = [startStr, null]
          dates.value = [startStr, undefined]
        } else if (!dates.value[0] && dates.value[1]) {
          state.dateRange = [null, endStr]
          dates.value = [undefined, endStr]
        } else {
          state.dateRange = []
          dates.value = []
        }
        return
      }
      state.dateRange = [startStr, endStr]
      // 保持锚点状态：如果当前处于单端选择中，让另一端继续处于待选状态
      if (dates.value[0] && !dates.value[1]) {
        dates.value = [startStr, undefined]
      } else if (!dates.value[0] && dates.value[1]) {
        dates.value = [undefined, endStr]
      } else {
        dates.value = [startStr, endStr]
      }
    } else if (startStr) {
      state.dateRange = [startStr, null]
      dates.value = [startStr, undefined]
    } else if (endStr) {
      state.dateRange = [null, endStr]
      dates.value = [undefined, endStr]
    } else {
      state.dateRange = []
      dates.value = []
    }
  }
}

const validateDateRange = () => {
  if (state.dateRange.length === 2 && state.dateRange[0] && state.dateRange[1]) {
    const start = dayjs(state.dateRange[0])
    const end = dayjs(state.dateRange[1])
    const diffDays = end.diff(start, 'days')
    if (diffDays < 0 || diffDays > 365) {
      const [startStr, endStr] = state.dateRange
      if (dates.value[0] && !dates.value[1]) {
        state.dateRange = [startStr, null]
        dates.value = [startStr, undefined]
      } else if (!dates.value[0] && dates.value[1]) {
        state.dateRange = [null, endStr]
        dates.value = [undefined, endStr]
      } else {
        state.dateRange = []
        dates.value = []
      }
      return true
    }
  }
  return true
}

const disabledDate = (current: any) => {
  if (!dates.value || dates.value.length === 0) return false
  const currentDate = dayjs(current)

  // 已有完整区间（重新打开时），开始/结束日期都可以选择任何时间
  if (dates.value.length === 2 && dates.value[0] && dates.value[1]) {
    return false
  }

  // 只选了开始时间，结束日期只能选 [开始, 开始+365]
  if (dates.value[0] && !dates.value[1]) {
    const start = dayjs(dates.value[0])
    const diffDays = currentDate.diff(start, 'days')
    return diffDays < 0 || diffDays > 365
  }

  // 只选了结束时间，开始日期只能选 [结束-365, 结束]
  if (!dates.value[0] && dates.value[1]) {
    const end = dayjs(dates.value[1])
    const diffDays = end.diff(currentDate, 'days')
    return diffDays < 0 || diffDays > 365
  }

  return false
}

const resetFun = () => {
  state.tableData.param.consultationNo = ''
  state.tableData.param.categoryCode = undefined
  state.tableData.param.phone = ''
  state.tableData.param.start = ''
  state.tableData.param.end = ''
  state.tableData.param.pageNum = 1
  state.dateRange = []
  dates.value = []
}

const getTableData = async () => {
  validateDateRange()
  if (state.dateRange.length === 2 && state.dateRange[0] && state.dateRange[1]) {
    state.tableData.param.start = state.dateRange[0]
    state.tableData.param.end = state.dateRange[1]
  } else {
    state.tableData.param.start = ''
    state.tableData.param.end = ''
  }
  state.tableData.loading = true
  try {
    const data: any = await fetchWithPaginationFallback(
      (param) => consultationStore.getConsultationPage(param),
      state.tableData.param
    )
    state.tableData.data = data.records || []
    state.tableData.total = data.total || 0
    state.tableData.param.pageNum = data.pageNum ?? state.tableData.param.pageNum
  } finally {
    state.tableData.loading = false
  }
}

const onConfirm = (record: any) => {
  Modal.confirm({
    transitionName: '',
    title: '提示',
    icon: () => h(ExclamationCircleOutlined),
    centered: true,
    content: '"确认处理"后用户将收到处理完成的通知，是否确认处理？',
    okText: '确认',
    cancelText: '取消',
    onOk: () => {
      return consultationStore.confirmConsultation(record.id).then(() => {
        message.success('处理成功')
        getTableData()
      })
    }
  })
}

const onPageChange = (page: number) => {
  state.tableData.param.pageNum = page
  getTableData()
}

const onShowSizeChange = (_current: number, size: number) => {
  state.tableData.param.pageSize = size
  state.tableData.param.pageNum = 1
  getTableData()
}

const onCreateUpdate = () => {
  message.success('操作成功')
  getTableData()
  dialogRef.value?.closeDialog()
}

const getCategoryList = async () => {
  try {
    const data: any = await dictionaryStore.getDict({ code: 'consultation_category' })
    categoryList.value = data || []
  } catch (err) {
    console.error('获取咨询类型失败', err)
    categoryList.value = []
  }
}

const getStoreList = async () => {
  try {
    const data: any = await storeStore.getStorePage({ pageNum: 1, pageSize: 100 })
    storeList.value = data.records || []
  } catch (err) {
    console.error('获取店铺列表失败', err)
    storeList.value = []
  }
}

const getUserList = async () => {
  try {
    const data: any = await userStore.getUserPage({ pageNum: 1, pageSize: 100 })
    userList.value = data.records || []
  } catch (err) {
    console.error('获取用户列表失败', err)
    userList.value = []
  }
}

const init = async () => {
  getCategoryList()
  getStoreList()
  getUserList()
  getTableData()
}

watch(
  () => route.name,
  (name) => {
    if (name === 'consultation') {
      getTableData()
    }
  }
)

onMounted(() => {
  console.log('consultationManagement onMounted')
  init()
})
</script>

<style scoped lang="less">
// .consultation-search :deep(.ant-form-item) {
//   margin-bottom: 0;
// }

.ml10 {
  margin-left: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.mt15 {
  margin-top: 15px;
}
</style>
